"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CANVAS_HEIGHT = exports.DEFAULT_CANVAS_WIDTH = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const react_1 = __importDefault(require("react"));
const signature_pad_1 = __importDefault(require("signature_pad"));
exports.DEFAULT_CANVAS_WIDTH = 300;
exports.DEFAULT_CANVAS_HEIGHT = 200;
/**
 * @typedef {object} SignatureProps
 * @property {number} [width]
 * @property {number} [height]
 * @property {boolean} [disabled]
 * @property {string} [value]
 * @property {(value: string) => void} [onChange]
 */
/**
 * @extends {React.Component<SignatureProps>}
 */
class Signature extends react_1.default.Component {
    /**
     * @param {SignatureProps} props
     */
    constructor(props) {
        super(props);
        this.canvasRef = react_1.default.createRef();
        /** @type {SignaturePad | undefined} */
        this.signaturePad = undefined;
    }
    componentDidMount() {
        this.signaturePad = new signature_pad_1.default(this.canvasRef.current, {
            penColor: 'black',
        });
        this.signaturePad.addEventListener('endStroke', () => {
            if (this.signaturePad) {
                const signature = this.signaturePad.toData();
                const { onChange } = this.props;
                if (onChange) {
                    onChange(JSON.stringify(signature));
                }
            }
        });
        this.signaturePad.fromData(this.getData());
        const { disabled } = this.props;
        if (disabled) {
            this.signaturePad.off();
        }
    }
    /**
     * @param {SignatureProps} prevProps
     */
    componentDidUpdate(prevProps) {
        if (!this.signaturePad) {
            return;
        }
        const { value, disabled } = this.props;
        if (value !== prevProps.value) {
            this.signaturePad.fromData(this.getData());
        }
        if (disabled) {
            this.signaturePad.off();
        }
        else if (prevProps.disabled) {
            this.signaturePad.on();
        }
    }
    // eslint-disable-next-line react/sort-comp
    getData() {
        const { value } = this.props;
        if (typeof value === 'string') {
            let data;
            try {
                data = JSON.parse(value);
            }
            catch (err) {
                // ..
            }
            if ((0, isArray_1.default)(data)) {
                return data;
            }
        }
        return [];
    }
    render() {
        const { width, height } = this.props;
        return react_1.default.createElement("canvas", { ref: this.canvasRef, width: width, height: height });
    }
}
Signature.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    disabled: prop_types_1.default.bool,
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
};
Signature.defaultProps = {
    width: exports.DEFAULT_CANVAS_WIDTH,
    height: exports.DEFAULT_CANVAS_HEIGHT,
    disabled: false,
    value: null,
    onChange: null,
};
exports.default = Signature;
//# sourceMappingURL=Signature.js.map